<template>
  <el-select v-bind="$attrs"
             v-on="$listeners"
             v-loading="loading"
             :multiple="$attrs.value instanceof Array"
             collapse-tags
             filterable>
    <el-option v-for="item in options_"
               :key="item.id"
               :label="item.name"
               :value="usingCode ? item.code : item.id">
    </el-option>
  </el-select>
</template>

<script>

  export default {
    name: 'RemoteSelect',
    props: {
      className: String,
      options: Array,
      selectFirst: {
        type: Boolean,
        default: false
      },
      removeSet: Set,
      usingCode: Boolean,
      selectAll: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        loading: false
      }
    },
    created () {
      if (this.options) return
      this.$store.dispatch('data/kvList', this.className)
    },
    computed: {
      options_ () {
        if (this.options) return this.options

        const options = []
        if (this.selectAll) {
          options.push({
            name: '全部',
            id: -1
          })
        }
        for (const item of this.$store.state.data[this.className] || []) {
          if (this.removeSet && this.removeSet.has(item.id)) continue

          options.push(item)
        }
        return options
      },
      change () {
        return {
          value: this.$attrs.value,
          options: this.options_
        }
      }
    },
    watch: {
      change: {
        handler ({ value, options }) {
          if (this.selectFirst && !value && options && options.length > 0) {
            this.$emit('input', options[0].id)
          }
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
</style>
